// extracted by mini-css-extract-plugin
export var contactInfo = "contact-module--contact-info--1yx49";
export var contactForm = "contact-module--contact-form--2ePUu";
export var map = "contact-module--map--1bn3m";
export var wrapper = "contact-module--wrapper--3TWk-";
export var contact = "contact-module--contact--SeQsF";